export const LIVESTREAM_MESSAGE_SEGMENT = 'livestream';
export const MEETING_MESSAGE_SEGMENT = 'meeting';

export function isMeetingMessageSegment(segment) {
  return segment === MEETING_MESSAGE_SEGMENT;
}
